/**
 * @flow
 * @relayHash bdb7ccd50f9ab0241abc3a7c7be39811
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type OrderSortField = "CREATED_AT" | "CUSTOMER" | "CUSTOMER_ORDER_NUMBER" | "ORDERED_AT" | "ORDER_NUMBER" | "PROMISED_AT" | "REQUIRED_AT" | "STATUS" | "UPDATED_AT";
export type SortDirection = "ASC" | "DESC";
export type OrderSort = {|
  field: OrderSortField,
  direction: SortDirection,
|};
export type SelectOrderFieldQueryVariables = {|
  sortBy?: ?OrderSort,
  customerIds?: ?$ReadOnlyArray<string>,
  search?: ?string,
  orderIds?: ?$ReadOnlyArray<string>,
|};
export type SelectOrderFieldQueryResponse = {|
  +orders: {|
    +edges: ?$ReadOnlyArray<?{|
      +node: {|
        +id: string,
        +orderNumber: string,
        +customer: {|
          +id: string,
          +name: string,
          +shippingAddressLine1: ?string,
          +shippingAddressLine2: ?string,
          +shippingAddressLine3: ?string,
          +shippingAddressCity: ?string,
          +shippingAddressState: ?string,
          +shippingAddressZip: ?string,
          +billingAddressLine1: ?string,
          +billingAddressLine2: ?string,
          +billingAddressCity: ?string,
          +billingAddressState: ?string,
          +billingAddressZip: ?string,
          +defaultAddress: ?{|
            +id: string,
            +addressLine1: ?string,
            +addressLine2: ?string,
            +addressLine3: ?string,
            +addressCity: ?string,
            +addressState: ?string,
            +addressZip: ?string,
          |},
        |},
        +shippingAddressLine1: ?string,
        +shippingAddressLine2: ?string,
        +shippingAddressLine3: ?string,
        +shippingAddressCity: ?string,
        +shippingAddressState: ?string,
        +shippingAddressZip: ?string,
        +yields: {|
          +edges: ?$ReadOnlyArray<?{|
            +node: {|
              +id: string,
              +orderedQuantity: number,
              +unitPrice: ?number,
              +discountPercent: ?number,
              +lineTotal: ?number,
              +item: {|
                +id: string,
                +name: string,
                +itemNumber: string,
                +quantityUOM: {|
                  +id: string,
                  +symbol: string,
                |},
              |},
            |}
          |}>
        |},
      |}
    |}>
  |}
|};
export type SelectOrderFieldQuery = {|
  variables: SelectOrderFieldQueryVariables,
  response: SelectOrderFieldQueryResponse,
|};
*/


/*
query SelectOrderFieldQuery(
  $sortBy: OrderSort
  $customerIds: [ID!]
  $search: String
  $orderIds: [ID!]
) {
  orders(first: 50, sortBy: $sortBy, customerIds: $customerIds, search: $search, orderIds: $orderIds) {
    edges {
      node {
        id
        orderNumber
        customer {
          id
          name
          shippingAddressLine1
          shippingAddressLine2
          shippingAddressLine3
          shippingAddressCity
          shippingAddressState
          shippingAddressZip
          billingAddressLine1
          billingAddressLine2
          billingAddressCity
          billingAddressState
          billingAddressZip
          defaultAddress {
            id
            addressLine1
            addressLine2
            addressLine3
            addressCity
            addressState
            addressZip
          }
        }
        shippingAddressLine1
        shippingAddressLine2
        shippingAddressLine3
        shippingAddressCity
        shippingAddressState
        shippingAddressZip
        yields {
          edges {
            node {
              id
              orderedQuantity
              unitPrice
              discountPercent
              lineTotal
              item {
                id
                name
                itemNumber
                quantityUOM {
                  id
                  symbol
                }
              }
            }
          }
        }
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "sortBy",
    "type": "OrderSort",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "customerIds",
    "type": "[ID!]",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "search",
    "type": "String",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "orderIds",
    "type": "[ID!]",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressLine1",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressLine2",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressLine3",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressCity",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressState",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "shippingAddressZip",
  "args": null,
  "storageKey": null
},
v9 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "orders",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "customerIds",
        "variableName": "customerIds"
      },
      {
        "kind": "Literal",
        "name": "first",
        "value": 50
      },
      {
        "kind": "Variable",
        "name": "orderIds",
        "variableName": "orderIds"
      },
      {
        "kind": "Variable",
        "name": "search",
        "variableName": "search"
      },
      {
        "kind": "Variable",
        "name": "sortBy",
        "variableName": "sortBy"
      }
    ],
    "concreteType": "OrderConnection",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "edges",
        "storageKey": null,
        "args": null,
        "concreteType": "OrderEdge",
        "plural": true,
        "selections": [
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "node",
            "storageKey": null,
            "args": null,
            "concreteType": "Order",
            "plural": false,
            "selections": [
              (v1/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "orderNumber",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "customer",
                "storageKey": null,
                "args": null,
                "concreteType": "Customer",
                "plural": false,
                "selections": [
                  (v1/*: any*/),
                  (v2/*: any*/),
                  (v3/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v6/*: any*/),
                  (v7/*: any*/),
                  (v8/*: any*/),
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressLine1",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressLine2",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressCity",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressState",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "ScalarField",
                    "alias": null,
                    "name": "billingAddressZip",
                    "args": null,
                    "storageKey": null
                  },
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "defaultAddress",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "CustomerAddress",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressLine1",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressLine2",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressLine3",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressCity",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressState",
                        "args": null,
                        "storageKey": null
                      },
                      {
                        "kind": "ScalarField",
                        "alias": null,
                        "name": "addressZip",
                        "args": null,
                        "storageKey": null
                      }
                    ]
                  }
                ]
              },
              (v3/*: any*/),
              (v4/*: any*/),
              (v5/*: any*/),
              (v6/*: any*/),
              (v7/*: any*/),
              (v8/*: any*/),
              {
                "kind": "LinkedField",
                "alias": null,
                "name": "yields",
                "storageKey": null,
                "args": null,
                "concreteType": "OrderYieldConnection",
                "plural": false,
                "selections": [
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "edges",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "OrderYieldEdge",
                    "plural": true,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "node",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "OrderYield",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "orderedQuantity",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "unitPrice",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "discountPercent",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "ScalarField",
                            "alias": null,
                            "name": "lineTotal",
                            "args": null,
                            "storageKey": null
                          },
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "item",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Item",
                            "plural": false,
                            "selections": [
                              (v1/*: any*/),
                              (v2/*: any*/),
                              {
                                "kind": "ScalarField",
                                "alias": null,
                                "name": "itemNumber",
                                "args": null,
                                "storageKey": null
                              },
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "quantityUOM",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "UOM",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "alias": null,
                                    "name": "symbol",
                                    "args": null,
                                    "storageKey": null
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "SelectOrderFieldQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v9/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "SelectOrderFieldQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v9/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "SelectOrderFieldQuery",
    "id": null,
    "text": "query SelectOrderFieldQuery(\n  $sortBy: OrderSort\n  $customerIds: [ID!]\n  $search: String\n  $orderIds: [ID!]\n) {\n  orders(first: 50, sortBy: $sortBy, customerIds: $customerIds, search: $search, orderIds: $orderIds) {\n    edges {\n      node {\n        id\n        orderNumber\n        customer {\n          id\n          name\n          shippingAddressLine1\n          shippingAddressLine2\n          shippingAddressLine3\n          shippingAddressCity\n          shippingAddressState\n          shippingAddressZip\n          billingAddressLine1\n          billingAddressLine2\n          billingAddressCity\n          billingAddressState\n          billingAddressZip\n          defaultAddress {\n            id\n            addressLine1\n            addressLine2\n            addressLine3\n            addressCity\n            addressState\n            addressZip\n          }\n        }\n        shippingAddressLine1\n        shippingAddressLine2\n        shippingAddressLine3\n        shippingAddressCity\n        shippingAddressState\n        shippingAddressZip\n        yields {\n          edges {\n            node {\n              id\n              orderedQuantity\n              unitPrice\n              discountPercent\n              lineTotal\n              item {\n                id\n                name\n                itemNumber\n                quantityUOM {\n                  id\n                  symbol\n                }\n              }\n            }\n          }\n        }\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'acfa45c60944178e01486a6a8a69f270';
module.exports = node;
